// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.siteEngagementMetricsWrapper__WMtwf {
  display: flex;
  flex-direction: column;
  flex: 0 0 calc(50% - 15px);
  min-width: 400px;
  height: 656px;
  background: var(--tables-primary-row-surface-default);
  box-shadow: 0px 3px 8px -1px rgba(50, 50, 71, 0.0509803922), 0px 0px 1px 0px rgba(12, 26, 75, 0.2392156863);
  position: relative;
}
@media (max-width: 1440px) {
  .siteEngagementMetricsWrapper__WMtwf {
    flex: 0 0 100%;
  }
}
.siteEngagementMetricsWrapper__WMtwf .hiddenSiteEngagementMetricsStatisticWrapper__Ck9ya {
  position: absolute;
  visibility: hidden;
  height: 0;
  width: 100%;
  z-index: -1;
}

.siteEngagementMetricsChartWrapper__Y3AxM {
  height: 476px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.siteEngagementMetricsChart__dSTtw {
  height: 100%;
  width: 100%;
}
.siteEngagementMetricsChart__dSTtw .highcharts-scrolling::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.siteEngagementMetricsChart__dSTtw .highcharts-scrolling::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.siteEngagementMetricsChart__dSTtw .highcharts-scrolling::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.siteEngagementMetricsChart__dSTtw .highcharts-scrolling::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
.siteEngagementMetricsChart__dSTtw .highcharts-fixed .highcharts-root path {
  fill: var(--tables-primary-row-surface-default);
}

.skeleton__ZuUaF {
  min-height: 397px;
}

.rightElementsWrapper__r8hY4 {
  display: flex;
  align-items: center;
  gap: 5px;
}

.filterIconWrapper__a7ix1 {
  padding: 5px;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.activeFilterIconWrapper__AiBbX {
  position: relative;
}
.activeFilterIconWrapper__AiBbX:after {
  content: "";
  position: absolute;
  top: -2px;
  right: -2px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--buttons-surface);
}

.filterIcon__aB81u {
  width: 24px;
  height: 24px;
}

.xAxisLabel__OYOMY span,
.yAxisLabel__WuIr2 span {
  color: var(--header-icon-secondary) !important;
  font-size: 12px !important;
  white-space: pre-line !important;
  text-align: right;
  font-family: "Roboto", sans-serif !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-clamp: 4;
}
.xAxisLabel__OYOMY path,
.yAxisLabel__WuIr2 path {
  stroke: var(--tables-primary-row-stroke);
}

.xAxisLabel__OYOMY span {
  width: 100px;
  text-align: left;
}

.legend__rxi3U span {
  color: var(--title-inputs-sections-title) !important;
  text-align: center;
  font-family: "Roboto", sans-serif !important;
  font-weight: 400;
  font-size: 11px !important;
  line-height: 120%;
  text-transform: uppercase;
}

.dataLabels__kNGhr span {
  color: var(--tables-primary-row-text-main) !important;
  text-align: center;
  font-family: "Roboto", sans-serif !important;
  font-weight: 500 !important;
  font-size: 11px !important;
  line-height: 120%;
}

@media print {
  .siteEngagementMetricsWrapper__WMtwf {
    box-shadow: unset;
  }
  .siteEngagementMetricsWrapper__WMtwf .hiddenSiteEngagementMetricsStatisticWrapper__Ck9ya {
    visibility: visible;
    height: unset;
    z-index: 1;
  }
  .siteEngagementMetricsWrapper__WMtwf .siteEngagementMetricsStatisticWrapper__PVtT_ {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/ExecutiveSummary/components/SiteEngagementMetrics/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,qDAAA;EACA,2GACE;EAMF,kBAAA;AA/EF;AA4EE;EAXF;IAYI,cAAA;EAzEF;AACF;AA4EE;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AA1EJ;;AA8EA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3EF;;AA8EA;EACE,YAAA;EACA,WAAA;AA3EF;AAPE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AASJ;AANE;EACE,+BAAA;EACA,kBAAA;AAQJ;AALE;EACE,8BAAA;EACA,kBAAA;AAOJ;AAJE;EACE,gBAAA;EACA,kBAAA;AAMJ;AAkEQ;EACE,+CAAA;AAhEV;;AAuEA;EACE,iBAAA;AApEF;;AAuEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AApEF;;AAuEA;EACE,YAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AApEF;;AAuEA;EACE,kBAAA;AApEF;AAsEE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kCAAA;AApEJ;;AAwEA;EACE,WAAA;EACA,YAAA;AArEF;;AA0EE;;EACE,8CAAA;EACA,0BAAA;EACA,gCAAA;EACA,iBAAA;EACA,4CAAA;EAzHF,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAuHE,qBAAA;EACA,aAAA;AAlEJ;AAqEE;;EACE,wCAAA;AAlEJ;;AAuEE;EACE,YAAA;EACA,gBAAA;AApEJ;;AAyEE;EACE,oDAAA;EACA,kBAAA;EACA,4CAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,yBAAA;AAtEJ;;AA2EE;EACE,qDAAA;EACA,kBAAA;EACA,4CAAA;EACA,2BAAA;EACA,0BAAA;EACA,iBAAA;AAxEJ;;AA4EA;EACE;IACE,iBAAA;EAzEF;EA2EE;IACE,mBAAA;IACA,aAAA;IACA,UAAA;EAzEJ;EA4EE;IACE,aAAA;EA1EJ;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.siteEngagementMetricsWrapper {\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 calc(50% - 15px);\n  min-width: 400px;\n  height: 656px;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow:\n    0px 3px 8px -1px #3232470d,\n    0px 0px 1px 0px #0c1a4b3d;\n\n  @media (max-width: 1440px) {\n    flex: 0 0 100%;\n  }\n  position: relative;\n\n  .hiddenSiteEngagementMetricsStatisticWrapper {\n    position: absolute;\n    visibility: hidden;\n    height: 0;\n    width: 100%;\n    z-index: -1;\n  }\n}\n\n.siteEngagementMetricsChartWrapper {\n  height: 476px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.siteEngagementMetricsChart {\n  height: 100%;\n  width: 100%;\n\n  :global {\n    .highcharts-scrolling {\n      @include scrollBar;\n    }\n    .highcharts-fixed {\n      .highcharts-root {\n        path {\n          fill: var(--tables-primary-row-surface-default);\n        }\n      }\n    }\n  }\n}\n\n.skeleton {\n  min-height: 397px;\n}\n\n.rightElementsWrapper {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.filterIconWrapper {\n  padding: 5px;\n  background-color: transparent;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n}\n\n.activeFilterIconWrapper {\n  position: relative;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: -2px;\n    right: -2px;\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background: var(--buttons-surface);\n  }\n}\n\n.filterIcon {\n  width: 24px;\n  height: 24px;\n}\n\n.xAxisLabel,\n.yAxisLabel {\n  span {\n    color: var(--header-icon-secondary) !important;\n    font-size: 12px !important;\n    white-space: pre-line !important;\n    text-align: right;\n    font-family: 'Roboto', sans-serif !important;\n\n    @include ellipsis-text;\n    -webkit-line-clamp: 4;\n    line-clamp: 4;\n  }\n\n  path {\n    stroke: var(--tables-primary-row-stroke);\n  }\n}\n\n.xAxisLabel {\n  span {\n    width: 100px;\n    text-align: left;\n  }\n}\n\n.legend {\n  span {\n    color: var(--title-inputs-sections-title) !important;\n    text-align: center;\n    font-family: 'Roboto', sans-serif !important;\n    font-weight: 400;\n    font-size: 11px !important;\n    line-height: 120%;\n    text-transform: uppercase;\n  }\n}\n\n.dataLabels {\n  span {\n    color: var(--tables-primary-row-text-main) !important;\n    text-align: center;\n    font-family: 'Roboto', sans-serif !important;\n    font-weight: 500 !important;\n    font-size: 11px !important;\n    line-height: 120%;\n  }\n}\n\n@media print {\n  .siteEngagementMetricsWrapper {\n    box-shadow: unset;\n\n    .hiddenSiteEngagementMetricsStatisticWrapper {\n      visibility: visible;\n      height: unset;\n      z-index: 1;\n    }\n\n    .siteEngagementMetricsStatisticWrapper {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"siteEngagementMetricsWrapper": `siteEngagementMetricsWrapper__WMtwf`,
	"hiddenSiteEngagementMetricsStatisticWrapper": `hiddenSiteEngagementMetricsStatisticWrapper__Ck9ya`,
	"siteEngagementMetricsChartWrapper": `siteEngagementMetricsChartWrapper__Y3AxM`,
	"siteEngagementMetricsChart": `siteEngagementMetricsChart__dSTtw`,
	"skeleton": `skeleton__ZuUaF`,
	"rightElementsWrapper": `rightElementsWrapper__r8hY4`,
	"filterIconWrapper": `filterIconWrapper__a7ix1`,
	"activeFilterIconWrapper": `activeFilterIconWrapper__AiBbX`,
	"filterIcon": `filterIcon__aB81u`,
	"xAxisLabel": `xAxisLabel__OYOMY`,
	"yAxisLabel": `yAxisLabel__WuIr2`,
	"legend": `legend__rxi3U`,
	"dataLabels": `dataLabels__kNGhr`,
	"siteEngagementMetricsStatisticWrapper": `siteEngagementMetricsStatisticWrapper__PVtT_`
};
module.exports = ___CSS_LOADER_EXPORT___;
